import { Award, Building2, Users, Target, Shield, TrendingUp, Home, MapPin, Star } from "lucide-react";

const AboutSection = () => {
  const reasons = [
    {
      icon: MapPin,
      title: "Local Expertise",
      description: "Deep knowledge of Nairobi's most coveted neighborhoods"
    },
    {
      icon: Shield,
      title: "Quality Assurance",
      description: "Every property personally vetted for excellence and value"
    },
    {
      icon: Users,
      title: "Client Focus",
      description: "Personalized service tailored to your lifestyle needs"
    },
    {
      icon: Home,
      title: "Lifestyle Curation",
      description: "We don't just sell properties, we curate living experiences"
    },
    {
      icon: Star,
      title: "Premium Service",
      description: "Global standards combined with Kenyan hospitality"
    },
    {
      icon: Award,
      title: "Trusted Guide",
      description: "Your reliable partner in finding the perfect address"
    }
  ];

  return (
    <section id="about" className="py-16 md:py-24 bg-brand-gradient">
      <div className="px-8 md:px-16 max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="font-open-sans font-semibold text-xs tracking-[0.3em] uppercase text-accent mb-6">
            About Wild Gates
          </p>
          <div className="max-w-3xl mx-auto">
            <p className="font-open-sans text-lg leading-relaxed text-primary-foreground/80">
              Our name is our philosophy. In a city as dynamic and vibrant as ours, finding a sanctuary that offers both luxury and security is paramount. 
              We specialize in curating living experiences within Nairobi's most coveted upmarket envelopes—Westlands, Riverside, Kileleshwa, Lavington, and Kilimani.
              We understand that our clients are not just looking for a property; they are looking for a lifestyle.
            </p>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="mb-20">
          <h3 className="font-open-sans font-bold text-2xl md:text-3xl text-primary-foreground text-center mb-12">
            Why Choose Wild Gates
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reasons.map((reason, index) => (
              <div key={reason.title} className="bg-background/10 border border-border/20 rounded-xl p-6 backdrop-blur-sm hover:bg-background/20 transition-colors group">
                <div className="flex items-center gap-4 mb-4">
                  <div className="p-2 bg-accent/10 rounded-lg group-hover:bg-accent/20 transition-colors">
                    <reason.icon className="w-5 h-5 text-accent" />
                  </div>
                  <h4 className="font-open-sans font-semibold text-sm text-primary-foreground group-hover:text-accent transition-colors">
                    {reason.title}
                  </h4>
                </div>
                <p className="font-open-sans text-xs text-primary-foreground/80 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Statistics Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
          {[
            { number: "3+", label: "Years in Kenya", color: "from-[#F3E9C86B] to-[#D4C08E1F]" },
            { number: "25+", label: "Properties Transferred", color: "from-[#FAF4E24D] to-[#C4AB7424]" },
            { number: "5", label: "Prime Locations", color: "from-[#1A3F22] via-[#24572f] to-[#08110b]" },
            { number: "100%", label: "Client Satisfaction", color: "from-[#D8B7C140] to-[#F3E9C81F]" }
          ].map((stat, index) => (
            <div key={stat.label} className={`bg-gradient-to-br ${stat.color} border border-border/20 rounded-xl p-6 text-center backdrop-blur-sm`}>
              <p className="font-open-sans text-3xl md:text-4xl font-bold text-primary-foreground mb-2">
                {stat.number}
              </p>
              <p className="font-open-sans text-xs tracking-widest uppercase text-primary-foreground/80">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {/* Brief Overview */}
        <div className="text-center mb-16">
          <div className="max-w-3xl mx-auto">
            <p className="font-open-sans text-base leading-relaxed text-primary-foreground/80">
              Our team comprises hyper-local experts who don't just know the streets but understand the nuances of each neighborhood. We combine global standards of real estate professionalism with deep-rooted Kenyan hospitality. 
              We are gatekeepers of quality, curators of communities, and your partners in finding the perfect address behind the gate.
            </p>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <a
            href="/about"
            className="inline-block font-open-sans font-bold text-xs tracking-[0.25em] uppercase bg-accent text-accent-foreground px-10 py-4 hover:bg-foreground hover:text-background transition-colors duration-300"
          >
            Learn More About Our Story
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
